import { FC, useEffect, useState, useCallback } from "react";
import { Accordion, AccordionItem } from "@appkit4/react-components";
import { UserType } from "routes/analysis/types/analysis";
import { getDate, parseLockStatus } from "services/common";
import ToolTip from "components/common/tooltip";
import { useAtomValue } from "jotai";
import { collapsedAtom } from "jotai/store";
import { UserData } from "routes/analysis/types/user";

const UserDataBox: FC<{ userData?: UserData }> = ({ userData }) => {
  const [visible, setVisible] = useState(false);
  const [float, setFloat] = useState(false);
  const [activeKeys, setActiveKeys] = useState<string[]>(["info"]);

  const collapsed = useAtomValue(collapsedAtom);


  const getUserName = useCallback(() => (
    <>
      <ToolTip content={UserType[userData?.type || "A"].name} position="bottom">
        <span
          className={`Appkit4-icon ${UserType[userData?.type || "A"].icon} mr-2`}
        ></span>
      </ToolTip>
      {userData?.userName}
    </>
  ), [userData]);

  const handleScroll = useCallback(() => {
    const visibleLimit = window.scrollY > 300;
    const floatLimit = window.scrollY >= 624;
    setVisible(collapsed ? false : visibleLimit);
    setFloat(floatLimit);
  }, [collapsed]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
  
  useEffect(() => {
    if (collapsed)
      setVisible(false);
  }, [collapsed]);
  return visible && userData
    ? (
      <div className={`ap-userdata-box ${float && "ap-userdata-float"}`}>
        <Accordion multiple={true} onClick={(value: string[]) => setActiveKeys(value)} activeKeys={activeKeys} style={{ padding: 0 }}>
          <AccordionItem title="User information" itemKey="info">
            <h2>{getUserName()}</h2>
            <div className="flex flex-col gap-4">
              <div>
                <p className="ap-font-medium">Full name</p>
                <p>{userData.fullName}</p>
              </div>
              <div>
                <p className="ap-font-medium">User group</p>
                <p>{userData.userGroup || "None assigned"}</p>
              </div>
              <div>
                <p className="ap-font-medium">Lock status</p>
                <p>{(parseLockStatus(parseInt(userData.lockStatus) || 0)) || "Not locked"}</p>
              </div>
              <div>
                <p className="ap-font-medium">Last logon</p>
                <p>{getDate(userData.lastLogon)}</p>
              </div>
              <div>
                <p className="ap-font-medium">Validity</p>
                <p>{userData && userData.validity.split(" - ").map(m => getDate(m.split(" ")[0])).join(" - ")}</p>
              </div>
            </div>
          </AccordionItem>
        </Accordion>
      </div>
    )
    : null
}

export default UserDataBox;
